<template>
  <div class="fu-drtab" data-test="fu-drawer-status-history">
    <p v-if="!items.length" class="fu-drtab__empty" data-test="fu-drawer-status-history-empty">No claim status history yet.</p>
    <div v-for="it in items" :key="it.key" class="fu-drtab__item">
      <div class="fu-drtab__main">
        <div class="fu-drtab__head">
          <span class="fu-drtab__badge">{{ it.title }}</span>
          <span class="fu-drtab__when">{{ it.when }}</span>
        </div>
        <div v-if="it.user" class="fu-drtab__meta">{{ it.user }}</div>
        <div v-if="it.note" class="fu-drtab__note">{{ it.shown }}</div>
        <button
          v-if="it.long"
          type="button"
          class="fu-drtab__more"
          :aria-expanded="String(!!open[it.key])"
          @click="open = Object.assign({}, open, { [it.key]: !open[it.key] })"
        >{{ open[it.key] ? 'Show less' : 'More' }}</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * DrawerStatusHistoryTab — "Status history": today's Claim Status History (claims only):
 * DateTimeEntry, Description, LogNote (text, More / Show less), UserName. Presentational.
 */
const LONG = 150;

export default {
  name: 'DrawerStatusHistoryTab',
  props: {
    tab: { type: Object, required: true },
    ctx: { type: Object, required: true },
  },
  data() {
    return { open: {} };
  },
  computed: {
    items() {
      const s = (this.tab.sections || [])[0];
      return ((s && s.rows) || []).map((r, i) => {
        const note = r.LogNote === null || r.LogNote === undefined ? '' : String(r.LogNote);
        const key = `h${i}`;
        const long = note.length > LONG;
        return {
          key,
          title: r.Description || 'Status',
          when: this.ctx.formatDateTime(r.DateTimeEntry),
          user: r.UserName || '',
          note,
          long,
          shown: long && !this.open[key] ? `${note.slice(0, LONG - 10).replace(/\s+\S*$/, '')}…` : note,
        };
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import './drawer';

.fu-drtab__empty { @include fu-dr-empty; }
.fu-drtab__item { @include fu-dr-item; }
.fu-drtab__main { flex: 1; min-width: 0; }
.fu-drtab__head { display: flex; align-items: center; flex-wrap: wrap; gap: 8px; }
.fu-drtab__badge { @include fu-pill($fu-neutral-100, $fu-neutral-700); font-size: 12px; }
.fu-drtab__when { margin-left: auto; font-size: 12px; color: $fu-text-subtle; white-space: nowrap; }
.fu-drtab__meta { @include fu-dr-item-meta; }
.fu-drtab__note { margin-top: 5px; font-size: 13px; line-height: 1.5; color: $fu-neutral-700; white-space: pre-line; overflow-wrap: anywhere; }
.fu-drtab__more { @include fu-link-btn; margin-top: 3px; font-size: 12px; font-weight: $fu-fw-bold; }
</style>
